import { Component } from '@angular/core';

@Component({
  selector: 'app-te-user-email',
  templateUrl: './te-user-email.component.html',
  styleUrls: ['./te-user-email.component.css']
})
export class TeUserEmailComponent {

}
